import { useLocalStorageState } from "hooks/useLocalStorageState";
import { createContext, ReactNode, use, useMemo } from "react";

const ALT_TOGGLE_MODE_KEY = "altToggleMode";

interface AltToggleModeContextValue {
  altToggleMode: boolean;
  setAltToggleMode: (value: boolean) => void;
}

const AltToggleModeContext = createContext<AltToggleModeContextValue | null>(
  null
);

interface AltToggleModeProviderProps {
  children: ReactNode;
}

export const AltToggleModeProvider = ({
  children,
}: AltToggleModeProviderProps): ReactNode => {
  const [altToggleMode, setAltToggleMode] = useLocalStorageState(
    ALT_TOGGLE_MODE_KEY,
    false
  );

  const value = useMemo(
    () => ({ altToggleMode, setAltToggleMode }),
    [altToggleMode, setAltToggleMode]
  );

  return <AltToggleModeContext value={value}>{children}</AltToggleModeContext>;
};

export const useAltToggleMode = (): AltToggleModeContextValue => {
  const context = use(AltToggleModeContext);
  if (context === null) {
    throw new Error(
      "useAltToggleMode must be used within an AltToggleModeProvider"
    );
  }
  return context;
};
